import { useEffect, useState } from 'react'
import api, { BMDialogBuilding } from '@api'

interface IState {
  building?: BMDialogBuilding
  isLoading: boolean
  update: (building: BMDialogBuilding) => void
}

export default function useBuilding(id?: string): IState {
  const [isLoading, setIsLoading] = useState(true)
  const [building, setBuilding] = useState<BMDialogBuilding | undefined>(undefined)
  useEffect(() => {
    if (id) {
      api.building.details(id).then((building: BMDialogBuilding) => {
        setIsLoading(false)
        setBuilding(building)
      })
    }
  }, [id])
  return {
    building,
    isLoading,
    update: (building) => setBuilding(building),
  }
}
